export const PROJECT_DETAILS = "PROJECT_DETAILS";